import React, { useState, useEffect, useRef, FC, Dispatch, SetStateAction } from 'react'
import { getGoogleCookieUserId } from 'lib/cookies'
import { useSelector } from 'react-redux'
import { getIndice } from 'selectors/algolia'
import { getSelectedCategoryRecentlyViewedCarousel } from 'selectors/algolia2/data'
import { getUserID } from 'selectors/user/session'
import { getAlgoliaUserToken } from 'selectors/user/cookie'
import CarouselV2 from 'components/SA/Carousel/v2'
import { getGoogleArtworksPLP, clickArtworkCarousel, GOOGLE } from '../helpers'
import Polaroid from '../ProductCarouselPolaroid'
import styles from './RecentlyViewed.module.scss'
import useCarouselImageLazyLoading from 'components/SA/Carousel/v2/useCarouselImageLazyLoading'
const MIN_ARTWORKS = 1
const LIST_ID = 'recently-viewed'
const LIST_NAME = 'Recently Viewed'
const DATA_API = GOOGLE

type RecentlyViewedCarouselProps = {
  shouldLoadComponent: boolean
  setShouldLoadComponent: Dispatch<SetStateAction<boolean>>
}

const RecentlyViewedCarousel: FC<RecentlyViewedCarouselProps> = (props) => {
  const { shouldLoadComponent, setShouldLoadComponent } = props
  /* Replacing connector */
  const algoliaSearchIndex = useSelector(getIndice)
  const selectedCategory = useSelector(getSelectedCategoryRecentlyViewedCarousel)
  const userId = useSelector(getUserID)
  const algoliaUserToken = useSelector(getAlgoliaUserToken)
  /* ============================================================== */
  const [artworks, handleArtworks] = useState([])
  const polaroidRef = useRef<HTMLDivElement>(null)
  const [polaroidWidth, setPolaroidWidth] = useState<number>(
    polaroidRef?.current?.offsetWidth || 311
  )
  const { handleImageLazyLoading, lastImageIndexLoaded } = useCarouselImageLazyLoading({
    offset: 5,
  })
  useEffect(() => {
    if (shouldLoadComponent) {
      const googleUserID = getGoogleCookieUserId()
      getGoogleArtworksPLP({
        callBack: handleArtworks,
        category: selectedCategory,
        visitorId: googleUserID,
        pageCategories: selectedCategory,
      })
    }
  }, [selectedCategory, shouldLoadComponent])

  useEffect(() => {
    if (!!polaroidRef?.current?.offsetWidth) {
      setPolaroidWidth(polaroidRef?.current?.offsetWidth)
    }
  }, [polaroidRef?.current?.offsetWidth])

  const handleClick = (ev: React.SyntheticEvent<Record<string, any>>) => {
    setShouldLoadComponent(false)
    clickArtworkCarousel(ev, algoliaSearchIndex, algoliaUserToken, userId)
  }

  if (!artworks || artworks.length < MIN_ARTWORKS) {
    return null
  }

  return (
    <div data-section={LIST_ID} className={styles.carouselWrapper}>
      <CarouselV2
        title={LIST_NAME}
        polaroidWidth={polaroidWidth}
        onScrollCallback={handleImageLazyLoading}
      >
        {artworks.map((artwork, index) => (
          <Polaroid
            key={index}
            polaroidRef={polaroidRef}
            artwork={artwork}
            onImageClick={handleClick}
            onTitleClick={handleClick}
            index={index}
            listId={LIST_ID}
            listName={LIST_NAME}
            dataApi={DATA_API}
            isLazyLoading={index > lastImageIndexLoaded}
          />
        ))}
      </CarouselV2>
    </div>
  )
}

export default RecentlyViewedCarousel
